/**
 * 아바타 표시 URL 해석 — design-20260606 §17 (서버 경유 방식).
 *
 * 운영 MinIO 는 브라우저에 비공개라 presigned 직결 GET 이 불가하다. 따라서 업로드 아바타는
 * chat-server 의 스트림 엔드포인트로 표시한다. avatarUrl 한 컬럼에 두 형태가 저장된다:
 *   - `https://...`/`http://...` → 그대로 외부 URL
 *   - `wcavatar:{ts}` (또는 legacy `wcfile:{id}`) → `/api/v1/users/{userId}/avatar?v={ts}`
 *       (쿠키 인증으로 <img> 가 직접 로드. ?v 는 캐시 무효화 토큰)
 *   - null/'' / 기타 → null (Avatar 가 이니셜 폴백)
 */

const API_BASE = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '/api/v1';
const WC_RE = /^wc(?:file|avatar):(\d+)$/;

/** raw avatarUrl + userId → 표시용 src(없으면 null). */
export function avatarImageUrl(userId: number | string, raw: string | null | undefined): string | null {
  if (typeof raw !== 'string' || raw.length === 0) return null;
  if (/^https?:\/\//i.test(raw)) return raw;
  const m = raw.match(WC_RE);
  if (m) return `${API_BASE}/users/${userId}/avatar?v=${m[1]}`;
  return null;
}
